import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity3 extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_3;
}

export default DirtRoadTileEntity3;
